import { render, staticRenderFns } from "./Galeria.vue?vue&type=template&id=6376438f&scoped=true&lang=pug"
import script from "./Galeria.vue?vue&type=script&lang=js"
export * from "./Galeria.vue?vue&type=script&lang=js"
import style0 from "./Galeria.styl?vue&type=style&index=0&id=6376438f&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6376438f",
  null
  
)

export default component.exports